module.exports = __webpack_public_path__ + "static/forecast/fresh-snow/thigh-ca6904ca2ab0c194c97669f7d6016209.svg";